import { useEffect, useState } from "react";
import { BasicButton } from "../../theme/Component/BasicButton";
import { BasicTable } from "../../theme/Component/BasicTable";
import { Modal } from "../../theme/Component/Modal";
import { ModalConfirm } from "../../theme/Component/ModalConfirm";
import { ListMenu } from "../../theme/Component/ListMenu";
import { toast } from "react-toastify";
import useDataBean from "../../../core/services/dataBean/useDataBean";
import { Singleton } from "../../../core/services/Singleton";
import { _Fingerprint, _PersonPhoto, _RelationshipByOwner } from "../../../core/services/dataBean/EntityCatalogVdos";
import { AccountEditor } from "../../editor/AccountEditor";
import { RelationshipTypeEditor } from "../../Talentohumano/ParametrosTalentoHumano/RelationshipType/RelationshipTypeEditor";
import { RelationshipClassConstants } from "./RelationshipClassConstants";
import { BasicSwitch } from "../../theme/Component/BasicSwitch";
import { FileInput } from "../../theme/Component/FileInput";

import { FingerType } from "./FingerType";
import { HandleTypes } from "./HandleTypes";
import { PhotoViews } from "./PhotoViews";
import { SideType } from "./SideType";
import { FileService } from "../../../core/services/FileService";




interface Props {
    accountID: number;
}

export const PersonPhoto = ({ accountID }: Props) => {

    const person = useDataBean(_PersonPhoto);
    const single = Singleton.getInstance();
    const [lista, setLista] = useState<any>([]);
    const fileService = new FileService();
    const [Type, setType] = useState<any>(null)
    const [modalentity, setModalentity] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });
    const [modaltype, setModaltype] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });
    const [modal, setModal] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });
    const [modalC, setModalC] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });

    useEffect(() => {
        getLista();
    }, [accountID])

    const getLista = () => {

        person.instance.getPersonPhoto(accountID).then(
            (resp: any) => {
               if (resp) {
                    let tmp = resp;
                    tmp.forEach((element: any) => {
                        if (element.DataBeanProperties.MediaContext) {
                            element.DataBeanProperties.URL = ` <a href="${fileService.getUrlFile(element.DataBeanProperties.MediaContext, element.DataBeanProperties.Media)}" target='_blank'>DESCARGAR DOCUMENTO</a>`
                        } else {
                            element.DataBeanProperties.URL = "Sin Documento";
                        }
                    });
                    setLista(tmp);
                } else {
                    setLista([]);
                }
            }
        )

    }

    const create = () => {
        person.setBean({
           
        });
        setModal({ ...modal, "view": true });
    }
    const deleteItem = () => {
        person.instance.deleteBioIdentity(person.bean.IDBioIdentity).then(
            (resp: any) => {
                getLista();
                setModalC({ ...modalC, "view": false });
            }
        )

    }
    const addPersonPhoto = () => {
        
        person.instance.addPersonPhoto(accountID,person.bean.ViewType,person.bean.SideType,person.bean.Media,person.bean.MediaContext,null).then(
            (resp: any) => {
                console.log(resp)
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }
    
    const head = [
        { title: 'ID', property: 'IDBioIdentity', visible: true },
        { title: 'Tipo de Vista', property: 'ViewTypeName', visible: true },
        { title: 'Lado de Toma', property: 'SideTypeName', visible: true },
        { title: 'Archivo de Imágen', property: 'URL', visible: true },
        { title: 'Creado', property: 'Since', visible: true },
        
    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [

            // { titulo: 'Editar', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModal({ ...modal, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }


    return (
        <div className="row">
            <label>Fotos de Identificación</label>
            <div className="col-md-12">
                <BasicTable body={lista} head={head} rowSet={person.setBean} iconButtons={iconButtonsItem} listButtons={listaBotones()}></BasicTable>
                <Modal modal={modal} updateModal={setModal} eventModal={addPersonPhoto}>
                    <div className="row">
                       <div className="col-md-12">
                        <FileInput
                                          Media={person.bean.Media}
                                          MediaContext={person.bean.MediaContext}
                                          directory='Rate'
                                          label='Archivo'
                                          docAcept='application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/pdf'
                        onCreate={(Filemap: any) => { person.setBean({ ...person.bean, "Media": Filemap.Media, "MediaContext": Filemap.MediaContext }); }}
                        ></FileInput>
                    </div>
                    <div className="col-md-6">
                        <PhotoViews idSelector={person.bean.ViewType} onChange={(e) => { person.setBean({ ...person.bean, "ViewType": e }) }}/>
                    </div>
                    <div className="col-md-6">
                        <SideType idSelector={person.bean.SideType} onChange={(e) => { person.setBean({ ...person.bean, "SideType": e }) }}/>
                    </div>
                    </div>
                </Modal>
                
                <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                    <strong>Eliminar item</strong>
                </ModalConfirm>
            </div>
        </div>
    )
}